export const tableDataComplex = [
  {
    question: "ok",
    answer: "Sorry, I couldn't provide a relevant answer based on the available information.",
    rating: 0,
    site_id: "544f88e2-f3db-45a5-9722-bf001742ef50",
    site_name: "OpenSpace",
    ip_address: "172.16.10.65",
    created_at: "2025-08-14T05:55:52.907354",
  },
  {
    question: "what is openspace services?",
    answer: "OpenSpace Services is a custom software development company that delivers bespoke, high-tech, and cutting-edge software solutions for SMEs, new businesses, and startup ventures. They specialize in full-cycle software development, including web and SaaS application development, product engineering, and MVP development. They use technologies such as Python, Java, Node.js, React.js, Next.js, and Express.js to build scalable and high-performance applications.",
    rating: 1,
    site_id: "544f88e2-f3db-45a5-9722-bf001742ef50",
    site_name: "OpenSpace",
    ip_address: "172.16.10.65",
    created_at: "2025-08-14T05:57:16.668157",
  },
  {
    question: "what is openspace",
    answer: "OpenSpace appears to be a company that provides various services, including software development, IT solutions, and digital transformation. They seem to offer customized solutions for businesses, startups, and enterprises, aiming to drive innovation and growth. OpenSpace also mentions being a strategic partner for companies, helping them stay competitive and relevant in today's dynamic market. According to the provided information, OpenSpace has a team of experts dedicated to delivering cutting-edge technology services, including software development, system integration, and more. They also have a range of case studies and services listed on their website, showcasing their work in different industries. Additionally, OpenSpace has a privacy policy in place, which outlines how they collect, store, and use personal information from individuals who interact with their website or services.",
    rating: 1,
    site_id: "544f88e2-f3db-45a5-9722-bf001742ef50",
    site_name: "OpenSpace",
    ip_address: "172.16.10.65",
    created_at: "2025-08-14T05:57:08.506578",
  },
  {
    question: "how are u",
    answer: "Sorry, I couldn't provide a relevant answer based on the available information.",
    rating: -1,
    site_id: "544f88e2-f3db-45a5-9722-bf001742ef50",
    site_name: "OpenSpace",
    ip_address: "172.16.10.65",
    created_at: "2025-08-14T05:56:50.452031",
  },
  {
    question: "what is openspace services?",
    answer: "OpenSpace Services is a custom software development company that delivers bespoke, high-tech, and cutting-edge software solutions for SMEs, new businesses, and startup ventures. They specialize in full-cycle SaaS and web application development, handling everything from conceptualization to deployment, and provide long-term support to ensure their clients' businesses run smoothly.",
    rating: 0,
    site_id: "544f88e2-f3db-45a5-9722-bf001742ef50",
    site_name: "OpenSpace",
    ip_address: "172.16.10.65",
    created_at: "2025-08-14T06:51:56.148187",
  },
  {
    question: "hello",
    answer: "Hello! How can I help you today?",
    rating: 1,
    site_id: "544f88e2-f3db-45a5-9722-bf001742ef50",
    site_name: "OpenSpace",
    ip_address: "172.16.10.65",
    created_at: "2025-08-14T07:21:54.563499",
  },
  {
    question: "what is openspace",
    answer: "<p>OpenSpace appears to be a company that provides various services, including software development, IT solutions, and digital transformation. They seem to offer customized solutions for businesses, startups, and individuals, aiming to drive innovation and growth. OpenSpace also provides services such as website development, mobile app development, and system integration.</p>\n\n<p>According to the available information, OpenSpace has a team of experts dedicated to delivering cutting-edge technology services, and they strive to empower organizations with the tools they need to thrive in the digital world. They also have a privacy policy in place, which outlines how they collect, store, and use personal information.</p>",
    rating: 1,
    site_id: "544f88e2-f3db-45a5-9722-bf001742ef50",
    site_name: "OpenSpace",
    ip_address: "172.16.10.65",
    created_at: "2025-08-14T07:22:12.916404",
  },
  {
    question: "i need hepl",
    answer: "Sorry, I couldn't provide a relevant answer based on the available information.",
    rating: -1,
    site_id: "544f88e2-f3db-45a5-9722-bf001742ef50",
    site_name: "OpenSpace",
    ip_address: "172.16.10.65",
    created_at: "2025-08-14T07:20:29.849328",
  },
  {
    question: "i need help",
    answer: "Sorry, I couldn't provide a relevant answer based on the available information.",
    rating: 0,
    site_id: "544f88e2-f3db-45a5-9722-bf001742ef50",
    site_name: "OpenSpace",
    ip_address: "172.16.10.65",
    created_at: "2025-08-14T07:24:38.444721",
  },
];
